import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=c6920d48&scoped=true&"
import script from "./StepTitle.vue?vue&type=script&lang=js&"
export * from "./StepTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6920d48",
  null
  
)

export default component.exports